import type { TimeRangeSelection } from "@/components/interactive/SharedTimeRange.types";
import { DynamicQueryParam } from "@/constants/query-params";

/** A selection as the params a time-aware surface reads back, mirroring `setSelection`. Elides no
 * default, since the page being handed the window need not share this one's. */
export const setTimeRangeSelectionParams = (
  params: URLSearchParams,
  selection: TimeRangeSelection,
): void => {
  switch (selection.kind) {
    case "relative":
      params.set(DynamicQueryParam.LOOKBACK_MS, String(selection.lookbackMs));
      return;
    case "since":
      params.set(DynamicQueryParam.START_DATE, String(selection.start.getTime()));
      return;
    case "absolute":
      params.set(DynamicQueryParam.START_DATE, String(selection.start.getTime()));
      params.set(DynamicQueryParam.END_DATE, String(selection.end.getTime()));
      return;
    case "unset":
      return;
  }
};
